import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PodrucjeGranicaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PodrucjeGranicaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <rect x="77.205" y="47.5" fill="#E6007C" width="22.795" height="5" />
      <rect x="67.205" y="47.5" fill="#E6007C" width="5" height="5" />
      <rect x="38.205" y="47.5" fill="#E6007C" width="24" height="5" />
      <rect x="28.205" y="47.5" fill="#E6007C" width="5" height="5" />
      <rect y="47.5" fill="#E6007C" width="23.205" height="5" />
    </svg>
  </SvgIcon>
}

export default PodrucjeGranicaIcon;
